import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

import { PostLoginResponseType, postLogin } from "service/api";
import * as yup from "yup";

import { Button, Img, Input, Text } from "components";

import useForm from "hooks/useForm";

import "react-toastify/dist/ReactToastify.css";
import { useAuthStore } from "store/auth";
import UseToast from "utils/AfToast";
import { GetCommanWay } from "API/commonApi";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { MovingButton } from "components/Button/moving-border";
import { SparklesCore } from "components/Other/sparkles";
import { BackgroundGradientAnimation } from "components/Other/BackgroundGradientAnimation";
import { HoverBorderGradient } from "components/Button/hover-border-gradient";
import { cn } from "../../utils/lib-utils";
import { AnimInput } from "components/Input/AnimInput";
import { debounce } from "lodash";

export const Login: React.FC = () => {
  const { setToken, setUser, token } = useAuthStore();
  const [login, setLogin] = React.useState<PostLoginResponseType>();
  const [togglePassVisible, setTogglePassVisible] = useState<boolean>(false);
  const formValidationSchema = yup.object().shape({
    username: yup.string().required("Username is required"),
    password: yup.string().required("Password is required"),
    pcId: yup.string().notRequired(),
  });
  const form = useForm(
    { username: "", password: "", pcId: "" },
    {
      validate: true,
      validateSchema: formValidationSchema,
      validationOnChange: true,
    }
  );
  const navigate = useNavigate();

  useEffect(() => {
    fetch("http://127.0.0.1:6789/device-id")
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP Error: ${res.status}`);
        return res.json();
      })
      .then((data) => {
        console.log("Fetch Success:", data);
        // Update your form or state here
        form.handleChange("pcId", data?.device_id);
      })
      .catch((err) => {
        console.error("Fetch Error:", err);
      });
  }, []); // Empty array ensures it runs only once on mount

  function login1(data: Partial<{ username: string; password: string; pcId: string }>) {
    const req = {
      data: { username: data?.username, password: data?.password, pcId: data?.pcId },
    };

    postLogin(req)
      .then((res: any) => {
        setLogin(res?.data);

        setToken(res?.data?.data?.token);
        setUser(res?.data?.data);

        localStorage.setItem("af_token", JSON.stringify(res?.data?.data?.token));

        navigate("/dashboard");
      })
      .catch((err) => {
        console.error(err);
        if (err?.response?.data?.message) {
          UseToast(err?.response?.data?.message, "error");
        } else {
          typeof data === "string" ? UseToast(err, "error") : UseToast(err.message, "error");
        }
      });
  }

  return (
    <>
      <div className="flex h-[100vh]">
        <div className="flex-1 bg-[#004394] flex items-center justify-center w-1/2">
          <BackgroundGradientAnimation>
            <div className="absolute z-50 inset-0 flex items-center justify-center text-white font-bold px-4 pointer-events-none text-3xl text-center md:text-4xl lg:text-7xl">
              {/*<p className="bg-clip-text text-transparent drop-shadow-2xl bg-gradient-to-b from-white/80 to-white/20">
                Gradients X Animations
              </p>*/}
              <div>
                <Img src={"/logo-white.png"} className="w-[300px] ml-auto" />
              </div>
            </div>
          </BackgroundGradientAnimation>
        </div>
        <div className="flex-1 bg-black-900 h-full flex font-opensans items-center justify-center mx-auto w-full">
          <div className="flex flex-col gap-6 items-center justify-start w-full">
            <div className="w-full bg-black-900 flex flex-col items-center justify-center overflow-hidden rounded-md">
              <h1 className="md:text-3xl sm:text-[32px] text-[48px] font-semibold text-center text-white relative z-20">
                {window.location.host == "portal.airfield.co.in" ? "Client " : "Employee "} Login
              </h1>
              <div className="w-[30rem] h-40 relative">
                {/* Gradients */}
                <div className="absolute inset-x-16 top-0 bg-gradient-to-r from-transparent via-indigo-500 to-transparent h-[2px] w-3/4 blur-sm" />
                <div className="absolute inset-x-16 top-0 bg-gradient-to-r from-transparent via-indigo-500 to-transparent h-px w-3/4" />
                <div className="absolute inset-x-48 top-0 bg-gradient-to-r from-transparent via-sky-500 to-transparent h-[5px] w-1/4 blur-sm" />
                <div className="absolute inset-x-48 top-0 bg-gradient-to-r from-transparent via-sky-500 to-transparent h-px w-1/4" />

                {/* Core component */}
                <SparklesCore
                  background="transparent"
                  minSize={0.4}
                  maxSize={2}
                  particleDensity={600}
                  className="w-full h-full"
                  particleColor="#FFFFFF"
                />

                {/* Radial Gradient to prevent sharp edges */}
                <div className="absolute inset-0 w-full h-full bg-black-900 [mask-image:radial-gradient(350px_200px_at_top,transparent_20%,white)]"></div>
              </div>
            </div>

            {/*<Text className=" md:text-3xl sm:text-[28px] text-[32px] text-blue_gray-900 font-opensans font-semibold">
              {window.location.host == "portal.airfield.co.in" ? "Client " : "Employee "} Login
            </Text>*/}
            <div className="-mt-[8rem] z-10 flex flex-col gap-4 items-center justify-start w-full font-sans text-xl leading-5">
              <div className="flex flex-col gap-1 items-start justify-start w-[400px] sm:w-full">
                <LabelInputContainer>
                  <label htmlFor="email" className="text-white">
                    Username
                  </label>
                  <AnimInput
                    name="email"
                    type="text"
                    onChange={(e) => {
                      form.handleChange("username", e.target.value);
                    }}
                    value={form?.values?.username}
                    id="email"
                    placeholder="Enter Your Username"
                    className="bg-slate-900/90 text-white text-lg"
                  />
                </LabelInputContainer>

                {/*<div className="text-white flex flex-col items-start justify-end pr-1 py-1 w-full">Username</div>
                <div className="bg-black-900 bg-opacity-50 flex flex-col gap-[15px] items-end justify-start mt-1 w-full">
                  <Input
                    name="email"
                    placeholder="Enter Your Username"
                    className="font-medium md:h-auto p-0 placeholder:text-blue_gray-300 sm:h-auto sm:pr-5 text-lg text-white text-left w-full "
                    wrapClassName="bg-white-A700 border border-blue_gray-100 border-solid p-3 rounded-lg w-full"
                    type="text"
                    onChange={(e) => {
                      form.handleChange("username", e);
                    }}
                    errors={form?.errors?.username}
                    value={form?.values?.username}
                  ></Input>
                </div>*/}
              </div>
              <div className="flex flex-col gap-1 items-start justify-start w-[400px] sm:w-full">
                <LabelInputContainer className="relative">
                  <label htmlFor="email" className="text-white">
                    Password
                  </label>
                  <AnimInput
                    name="password"
                    type={togglePassVisible ? "text" : "password"}
                    onChange={(e) => {
                      form.handleChange("password", e.target.value);
                    }}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        form.handleSubmit(login1);
                      }
                    }}
                    value={form?.values?.password}
                    id="password"
                    placeholder="Enter Your Password"
                    className="bg-slate-900/90 text-white text-lg"
                  />
                  <Img
                    className="h-5 mt-0 mr-3 absolute right-0 top-0"
                    src="images/img_eye.svg"
                    alt="eye"
                    style={{marginTop: 1}}
                    onClick={() => {
                      setTogglePassVisible(!togglePassVisible);
                    }}
                  />
                </LabelInputContainer>
                {/*<div className="text-white flex flex-col items-start justify-end pr-1 py-1 w-full">Password</div>
                <div className="flex flex-col gap-[15px] items-end justify-start mt-1 w-full">
                  <Input
                    name="InputField"
                    placeholder="Enter Password"
                    className="font-medium p-0 placeholder:text-blue_gray-300 text-lg leading-5 text-blue_gray-300 text-left w-full"
                    wrapClassName="bg-white-A700 border border-blue_gray-100 border-solid flex pl-3 py-3 rounded-lg w-[400px] sm:w-full"
                    type={togglePassVisible ? "text" : "password"}
                    onChange={(e) => {
                      form.handleChange("password", e);
                    }}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        form.handleSubmit(login1);
                      }
                    }}
                    errors={form?.errors?.password}
                    value={form?.values?.password}
                    suffix={
                      <Img
                        className="h-5 ml-[35px] mr-3"
                        src="images/img_eye.svg"
                        alt="eye"
                        onClick={() => {
                          setTogglePassVisible(!togglePassVisible);
                        }}
                      />
                    }
                  ></Input>
                  
                </div>*/}
              </div>
              {/*<Button
                className="mt-3 common-pointer bg-[#004394] text-white text-xl cursor-pointer font-medium py-2 pb-3 text-center w-[400px] border-2 border-black-900 border-l-4 border-t-4 rounded-xl"
                onClick={() => {
                  form.handleSubmit(login1);
                }}
              >
                Log in
              </Button>*/}

              <div className="mt-3">
                <MovingButton
                  borderRadius="18px"
                  className="bg-slate-900/50 text-black text-white border-slate-800 font-medium text-xl group/btn"
                  onClick={() => {
                    form.handleSubmit(login1);
                  }}
                >
                  Log in
                </MovingButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const BottomGradient = () => {
  return (
    <>
      <span className="group-hover/btn:opacity-100 block transition duration-500 opacity-0 absolute h-px w-full -bottom-px inset-x-0 bg-gradient-to-r from-transparent via-cyan-500 to-transparent" />
      <span className="group-hover/btn:opacity-100 blur-sm block transition duration-500 opacity-0 absolute h-px w-1/2 mx-auto -bottom-px inset-x-10 bg-gradient-to-r from-transparent via-indigo-500 to-transparent" />
    </>
  );
};

const LabelInputContainer = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return <div className={cn("flex flex-col space-y-2 w-full", className)}>{children}</div>;
};
